// extracted by mini-css-extract-plugin
export var container = "RequestServicesModal-module--container--c0a75";
export var desktopHidden = "RequestServicesModal-module--desktopHidden--31b75";
export var fadeInAnimation = "RequestServicesModal-module--fadeInAnimation--d3250";
export var formWrap = "RequestServicesModal-module--formWrap--9b3db";
export var loaderWrap = "RequestServicesModal-module--loaderWrap--529b7";
export var mobileHidden = "RequestServicesModal-module--mobileHidden--e7020";
export var title = "RequestServicesModal-module--title--2c0d9";
export var withoutAside = "RequestServicesModal-module--withoutAside--1646c";